<template lang='pug'>
    section.pessoa
        BaseHeader(
            :titulo="$t('mensagens.pessoas.titulo')",
            icon='mdi mdi-account-plus',
            :btnTexto="$t('mensagens.pessoas.cadastrarPessoa')",
            :exibeBotao='true',
            @btnHeaderClicado='cadastrarRepresentante'
        )

        .view-container-base-header
            .pessoa__barra-pesquisa
                i.el-icon-search
                input.lista-pessoa__barra-pesquisa__input(
                    v-model='search',
                    type='text',
                    :placeholder="$t('mensagens.pessoas.placeholder')",
                    autocomplete='off',
                    @keyup.enter='onChangeSearchInput'
                )

            .pessoa__tabela
                el-table.table-representantes(
                    height='100%',
                    :data='representantes',
                    v-loading='loading',
                    @sort-change='sortChangeRequest',
                    style='width: 100%'
                )
                    el-table-column(type='expand')
                        template(slot-scope='props')
                                span.mx-4(v-if='props.row.telefone') {{ $t('mensagens.pessoas.telefoneCelular') }}: &nbsp;
                                    span.phone-number {{ props.row.telefone }}
                                span.mx-4(v-if='props.row.telefoneAdicional') {{ $t('mensagens.pessoas.telefoneCelularAdicional') }}: &nbsp;
                                    span.phone-number {{ props.row.telefoneAdicional }}
                                span.mx-4(v-if='!props.row.telefone && !props.row.telefoneAdicional') {{ $t('mensagens.pessoas.naoHaTelefoneCadastrado') }}
                                span.mx-4(v-if='fPL1182CodigoLyraPessoa && props.row.codigoLyra && usuarioLogado.paisGrupo === ambientes.BRASIL') {{ $t('mensagens.pessoas.codigoLyra') }}: &nbsp;
                                    span.phone-number {{ props.row.codigoLyra }}

                    el-table-column(
                        prop='nomeRazaoSocial',
                        :label="$t('mensagens.pessoas.tabela.nome')",
                        sortable='custom',
                        min-width='350'
                    )

                    el-table-column(
                        :formatter='formatDocTableColumn',
                        prop='cpfCnpj',
                        :label="$t('mensagens.pessoas.tabela.documento')",
                        min-width='200'
                    )

                    el-table-column(prop='email', label='E-mail', min-width='250')

                    el-table-column(
                        prop='idCliente',
                        :label="$t('mensagens.pessoas.tabela.idPessoa')",
                        min-width='100'
                    )

                    el-table-column(
                        v-if='fPL1182CodigoLyraPessoa && usuarioLogado.paisGrupo === ambientes.PARAGUAY',
                        prop='codigoLyra',
                        :label="$t('mensagens.pessoas.codigoLyra')",
                        min-width='100'
                    )

                    el-table-column(
                        v-if='usuarioLogado.paisGrupo === ambientes.BRASIL',
                        prop='grupoEmpresas',
                        :label="$t('mensagens.pessoas.grupoEmpresa')",
                        min-width='200'
                    )

                    el-table-column(
                        v-if='usuarioLogado.paisGrupo === ambientes.BRASIL',
                        prop='tipoProduto',
                        :label="$t('mensagens.pessoas.tipoProduto')",
                        min-width='100'
                    )

                    el-table-column(
                        v-if='usuarioLogado.paisGrupo === ambientes.BRASIL',
                        prop='carProprio',
                        :label="$t('mensagens.pessoas.carProprio')",
                        min-width='100'
                    )
                        template(slot-scope='scope')
                            span {{ scope.row.carProprio ? 'Sim' : 'Não' }}

                    el-table-column(min-width='100', align='center', :label="$t('mensagens.comuns.acoes')")
                        .template(slot-scope='scope')
                            el-dropdown.action-button(trigger='click')
                                span.el-dropdown-link
                                    i.mdi.mdi-dots-vertical
                                el-dropdown-menu(slot='dropdown')
                                    el-dropdown-item(
                                        icon='el-icon-edit',
                                        @click.native='editarRepresentante(scope.row)'
                                    ) {{ $t('mensagens.comuns.editar') }}

                                    el-dropdown-item(
                                        icon='el-icon-delete',
                                        @click.native='handleOpenModalDeleteRepresentante(scope.row)'
                                    ) {{ $t('mensagens.comuns.remover') }}

                                    el-dropdown-item(
                                        v-if='scope.row.tipoDocumento.id === 1'
                                        icon='flow flow-environment',
                                        @click.native='abrirModalDiagnosticoSocioambiental(scope.row)'
                                    ) {{ $t('mensagens.pessoas.diagnosticoSocioambiental') }}

                    template(slot='empty')
                        el-empty(
                            :description="$t('mensagens.pessoas.voceNaoPossuiPessoasCadastradas')"
                        )

                .tabela-rodape
                    .tabela-rodape--esquerda
                        p {{ totalRepresentantes }} {{ $t('mensagens.pessoas.pessoas') }}

                    .tabela-rodape--pagination
                        el-pagination(
                            background,
                            :page-size='paginacao.tamanhoPagina',
                            :current-page.sync='paginacao.paginaAtual',
                            layout='prev, pager, next',
                            :total='totalRepresentantes',
                            @current-change='atualizarPagina'
                        )

        #modal-delete-representante-are-you-sure.row(
            v-show='deleteRepresentanteModal'
        )
            el-dialog(
                :visible.sync='deleteRepresentanteModal',
                width='500px',
                :before-close='handleCloseModalDeleteRepresentante'
            )
                .column.d-flex.justify-content-center.align-items-center.flex-column
                    h2.font-weight-bold.mb-5
                        | Atenção!
                    h4.text-center.mb-4(
                        v-if='deleteRepresentanteVinculadoModal',
                        style='word-break: keep-all'
                    )
                        | {{ $t('mensagens.pessoas.possuiTerritoriosVinculados') }}
                    h4.text-center.mb-4(style='word-break: keep-all')
                        | {{ $t('mensagens.pessoas.desejaRemover') }}
                    br
                    .buttons.col-12.row.justify-content-between
                        button.px-5.btn.btn-cancel.btn-block.w-40(
                            @click='handleCloseModalDeleteRepresentante'
                        )
                            | {{ $t('mensagens.comuns.cancelar') }}
                        button.delete.px-5.btn.el-button--primary.btn-block.btn-add-diagnostic.w-40(
                            @click='deleteRepresentante'
                        )
                            | {{ $t('mensagens.comuns.remover') }}

        ModalEditarCadastrarRepresentanteParaguai(
            v-if="fFPL124UploadDocumentosDocsPessoais && usuarioLogado.paisGrupo === ambientes.PARAGUAY"
            :mostrar='mostrarModalEditarCadastrarRepresentante',
            :dadosRepresentante='dadosRepresentanteCadastro',
            :editar='editar',
            @atualizarListaRepresentantes='fetchRepresentantes',
            @fechar='fecharModalEditarCadastrarRepresentante'
        )

        ModalEditarCadastrarRepresentante(
            v-else
            :mostrar='mostrarModalEditarCadastrarRepresentante',
            :dadosRepresentante='dadosRepresentanteCadastro',
            :editar='editar',
            @atualizarListaRepresentantes='fetchRepresentantes',
            @fechar='fecharModalEditarCadastrarRepresentante'
        )

        ModalDiagnosticoSocioambientalRepresentante(
            :mostrar='mostrarModalDiagnosticoSocioambiental',
            :dadosRepresentante='dadosRepresentanteDiagnostico',
            @fechar='mostrarModalDiagnosticoSocioambiental = false'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import EmptyResult from '@/components/EmptyResult.vue';
import ModalDiagnosticoSocioambientalRepresentante from '@/components/ModalDiagnosticoSocioambientalRepresentante.vue';
import ModalEditarCadastrarRepresentante from '@/components/ModalEditarCadastrarRepresentante.vue';
import ModalEditarCadastrarRepresentanteParaguai from '../../components/ModalEditarCadastrarRepresentanteParaguai.vue';
import validators from '@/utils/validators';
import formatters from '@/utils/formatters';
import representanteService from '@/services/RepresentanteService';
import TerritorioService from '@/services/TerritorioService';
import { mapGetters } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import { formatFlag } from '@/utils/featureFlags/featureFlag';
import { FeatureFlagConst } from '@/constants/FeatureFlag';

export default {
    name: 'index',
    components: {
        BaseHeader,
        EmptyResult,
        ModalDiagnosticoSocioambientalRepresentante,
        ModalEditarCadastrarRepresentante,
        ModalEditarCadastrarRepresentanteParaguai
    },

    data() {
        return {
            representantes: [],
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 20
            },
            totalRepresentantes: 0,
            search: '',
            order: null,
            deleteRepresentanteModal: false,
            deleteRepresentanteVinculadoModal: false,
            selectedRepresentante: {},
            mostrarModalDiagnosticoSocioambiental: false,
            dadosRepresentanteDiagnostico: {},
            mostrarModalEditarCadastrarRepresentante: false,
            dadosRepresentanteCadastro: {},
            editar: false,
            loading: false,
            ambientes: AmbientesEmpresas,
            fFPL124UploadDocumentosDocsPessoais: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF4390_CADASTRO_TERRITORIO_SISE)),
            fPL1182CodigoLyraPessoa: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF1182_CODIGO_LYRA_PESSOAS))
        };
    },

    mounted() {
        this.fetchRepresentantes();

        if (this.$route.params.cadastrar) {
            this.mostrarModalEditarCadastrarRepresentante = true;
            this.editar = false;

            if (this.$route.params.cadastrar.length !== 1) {
                if (this.$route.params.cadastrar !== ':cadastrar') {
                    let cadastrar = this.$route.params.cadastrar;
                    if (this.isCNPJ(cadastrar) || this.isCPF(cadastrar)) {
                        this.dadosRepresentanteCadastro = {
                            cpfCnpj: formatters.numeralStringFormatToDocumento(formatters.removerPontuacaoDocumento(cadastrar)),
                            tipoDocumento: {
                                id: 1,
                                nome: 'CPF/CNPJ',
                                siglaPais: 'BR'
                            }
                        };
                    } else {
                        this.dadosRepresentanteCadastro = {
                            nomeRazaoSocial: cadastrar
                        };
                    }
                }
            }
        }
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        pagedTableData() {
            return this.tableData.slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
            );
        }
    },

    methods: {
        atualizarPagina() {
            this.fetchRepresentantes();
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.page = this.paginacao.paginaAtual - 1;

            filtro.searchText = this.search || '';

            if (validators.validarCPF(this.search)) {
                filtro.searchText = formatters.documentoFormatToNumeral(
                    this.search
                );
            }

            if (this.order != null) {
                filtro.order = `&sort=nome_razao_social,${this.order}`;
            } else {
                filtro.order = '&sort=nome_razao_social,asc';
            }

            return filtro;
        },

        formatarTextoBusca() {
            if (this.search) {
                const doc = formatters.documentoFormatToNumeral(this.search);
                this.search = doc === '' ? this.search : doc;
            }
        },

        fetchRepresentantes() {
            this.formatarTextoBusca();
            if (this.search.length === 0 || this.search.length > 2) {
                this.loading = true;
                representanteService
                    .findAllByFiltro(this.getFiltros())
                    .then(response => {
                        this.representantes = response.data.resultados;
                        this.totalRepresentantes =
                            response.data.totalResultados;
                        this.loading = false;
                    });
            } else {
                this.$notify.warning({
                    message: this.$t('mensagens.pessoas.digiteTresCaracteresParaPesquisar')
                });
            }
        },

        cadastrarRepresentante() {
            this.editar = false;
            this.mostrarModalEditarCadastrarRepresentante = true;
        },

        editarRepresentante({
                                id,
                                cpfCnpj,
                                nomeRazaoSocial,
                                email,
                                idCliente,
                                codigoLyra,
                                tipoDocumento,
                                grupoEmpresas,
                                tipoProduto,
                                carProprio,
                                telefone,
                                telefoneAdicional,
                                arquivos
                            }) {
            this.dadosRepresentanteCadastro = {
                id,
                email,
                idCliente,
                codigoLyra,
                nomeRazaoSocial,
                tipoDocumento,
                cpfCnpj: formatters.numeralStringFormatToDocumento(cpfCnpj),
                grupoEmpresas,
                tipoProduto,
                carProprio,
                telefone,
                telefoneAdicional,
                arquivos
            };

            this.editar = true;
            this.mostrarModalEditarCadastrarRepresentante = true;
        },

        fecharModalEditarCadastrarRepresentante() {
            this.dadosRepresentanteCadastro = {};
            this.mostrarModalEditarCadastrarRepresentante = false;
        },

        deleteRepresentante() {
            representanteService
                .delete(this.selectedRepresentante.id)
                .then(response => {
                    if (response.status === 200) {
                        this.deleteRepresentanteModal = false;
                        this.$notify.success({
                            message: this.$t('mensagens.pessoas.pessoaRemovida')
                        });

                        this.reloadRepresentantes();
                    } else {
                        this.$notify.error({
                            message: this.$t('mensagens.pessoas.erroAoRemoverPessoa')
                        });
                    }
                });
        },

        async handleOpenModalDeleteRepresentante(representante) {
            this.selectedRepresentante.id = representante.id;
            let hasBoundTerritoryResponse =
                await TerritorioService.verificarRepresentante(
                    representante.id
                );

            this.deleteRepresentanteModal = true;
            if (hasBoundTerritoryResponse.data) {
                this.deleteRepresentanteVinculadoModal = true;
            }
        },

        handleCloseModalDeleteRepresentante() {
            this.deleteRepresentanteModal = false;
            this.deleteRepresentanteVinculadoModal = false;
        },

        onChangeSearchInput() {
            this.paginacao.paginaAtual = 1;
            this.fetchRepresentantes();
        },

        formatDocTableColumn(row, column, documento, index) {
            return formatters.numeralStringFormatToDocumento(documento);
        },

        reloadRepresentantes() {
            // Caso só possua 1 representante na pagina e a página não for a primeira, força a atualização da página
            // para a anterior
            if (
                this.representantes &&
                this.representantes.length === 1 &&
                this.paginacao.paginaAtual > 1
            ) {
                this.paginacao.paginaAtual = this.paginacao.paginaAtual - 1;
            }
            this.fetchRepresentantes();
        },

        abrirModalDiagnosticoSocioambiental({ cpfCnpj, nomeRazaoSocial }) {
            this.dadosRepresentanteDiagnostico = {
                nome: nomeRazaoSocial,
                cpfCnpj: formatters.numeralStringFormatToDocumento(cpfCnpj)
            };
            this.mostrarModalDiagnosticoSocioambiental = true;
        },

        sortChangeRequest(column) {
            this.order = null;

            if (column.order === 'ascending') {
                this.order = 'asc';
            } else if (column.order === 'descending') {
                this.order = 'desc';
            }
            this.fetchRepresentantes();
        },
        isCPF(input) {
            const numbers = formatters.removerPontuacaoDocumento(input);
            return numbers.length === 11 && validators.validarCPF(numbers);
        },
        isCNPJ(input) {
            const numbers = formatters.removerPontuacaoDocumento(input);
            return numbers.length === 14 && validators.validarCNPJ(numbers);
        }
    }
};
</script>

<style lang='scss' scoped>
.pessoa {
    height: 100%;
    width: 100%;

    .pessoa__barra-pesquisa {
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-pessoa__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .table-pessoa {
        height: 100%;
        width: 100%;
        background-color: var(--white);
        border-radius: $default-border-radius;
        border-color: var(--default-border-color);
    }

    .pessoa__tabela {
        height: calc(100vh - 312px);

        .el-table {
            border-radius: 5px 5px 0 0;
        }

        .table-representantes .phone-number {
            font-weight: 500;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 0 0 5px 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    button {
        width: fit-content;
        cursor: pointer;

        i {
            margin-right: 10px;
        }
    }

    #end-add-representante-button {
        p {
            cursor: pointer;
        }
    }

    .buttons .delete {
        margin-top: 0;
    }

    .el-table {
        .cell {
            word-break: normal !important;
        }

        .action-button {
            cursor: pointer;
        }
    }
}

.form-control {
    height: 2.5em !important;
    margin-bottom: 1.5rem;
}

.modal-socioambiental {
    max-height: 500px;
    overflow: auto;
}

#modal-diagnostico-socioambiental {
    text-align: left;
}

#editRepresentanteButtons {
    button {
        width: 100px;
    }
}
</style>
